import BreadCrumbWrapper from "components/global/BreadCrumbs/BreadCrumbs";
import { useEffect } from "react";
import { useHistory } from "react-router";
import BusinessSearchResourcesNotice from "../components/BusinessSearchResourcesNotice";
import BusinessWrapper from "../components/BusinessWrapper";
import { fetchAndSetOrganizationData, $list, handleSaveOpportunityFromSearchResults, handleRemoveSavedOpportunityFromSearchResults } from "./BusinessLenders.helpers";
import { Button, Row, Col, Container, Alert } from "react-bootstrap";
import {
  handleSortChange,
} from "../BusinessSearchResults/BusinessSearchResults.helpers";
import SimpleTable from "components/global/SimpleTable";
import { addHttpsToUrl } from "libs/string";
import userAccountSignal from "signals/UserAccount.signal";

function BusinessLenders() {
  const history = useHistory();

  const { lenders, businessFavorites } = $list.value;

  const business = userAccountSignal.value.userData?.account?.business;

  useEffect(() => {
    if (business) {
      if (!business.county || 
        !business.yearBusinessOpened || 
        (business.employment?.numberOfFullTimeEmployees === null || business.employment?.numberOfFullTimeEmployees === undefined) ||
        !business.assistance?.loanAmount || 
        !business.assistance?.loanPurpose || 
        (business.finance?.previousAnnualRevenue === null || business.finance?.previousAnnualRevenue === undefined)
      ) {
        return history.replace(`/business/quick-matching`)
      }

      fetchAndSetOrganizationData();
    }
  }, [location.search])

  return (
    <BusinessWrapper>
      <BreadCrumbWrapper labels={['Search Lenders']}>
        <Container fluid className="py-16">
          <Row>
            <Col>
              <Row>
                <Col className="text-center">
                  <h3 className="mb-16">Lenders</h3>

                  <Alert variant="info" className="my-24">
                    <p className="mb-0">
                      All of these institutions are offering financing.
                    </p>
                  </Alert>
                </Col>
              </Row>

              <div className="bg-white p-32 border border-gray shadow-sm">
              {/*
                <div className="d-flex mb-16">
                  <SimpleTableFilterDropdown
                    filtersState={dropdownFilters}
                    onChange={({ name, value }) =>
                      setDropdownFilter({ name, value })
                    }
                    onApply={(filters) => {
                      setAppliedFilters(filters);
                      fetchAndSetOrganizationData();
                    }}
                    onClearFilterInputs={resetBusinessSearchResultsFilterInputs}
                    filters={[
                      {
                        type: 'integer',
                        label: 'ID',
                        key: 'id',
                      },
                      {
                        type: 'select',
                        label: 'Name',
                        key: 'name',
                        options: lenders
                          .map((lender) => ({
                            value: `${lender.id}`,
                            label: lender.name,
                          }))
                      },
                    ]}
                  />
                </div>
                */}
                <SimpleTable
                  headers={[
                    {
                      key: 'name',
                      title: 'Name',
                      // sortable: true,
                    },
                    {
                      key: 'phoneNumber',
                      title: 'Phone Number',
                    },
                    {
                      key: 'website',
                      title: 'Website',
                    },
                    {
                      key: 'actions',
                      title: 'Actions',
                    },
                  ]}
                  rows={lenders.map((lender) => {
                    const isFavorite = businessFavorites?.find((fav) => fav.lenderId === lender.id);

                    return {
                      name:
                        lender.name,
                      phoneNumber: ({ key }: { key: string}) => (

                        <td key={key}>
                          {lender.phoneNumber ?
                            <a href={`tel:${lender.phoneNumber}`}>
                              {lender.phoneNumber}
                            </a>
                          : '-'}
                        </td>
                      ),
                      website: ({ key }: { key: string }) => (
                        <td key={key}>
                          {lender.website ?
                          <a
                            href={
                              lender.website
                                ? addHttpsToUrl(lender.website)
                                : ''
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {lender.website}
                          </a>
                          : '-'}
                        </td>
                      ),
                      actions: ({ key }: { key: string }) => (
                        <td key={key}>
                          <div className="d-flex flex-row justify-content-end">
                            <Button
                              size="sm"
                              hidden={isFavorite}
                              onClick={() =>
                                handleSaveOpportunityFromSearchResults({
                                  lenderId: lender.id,
                                  ventureCapitalFirmId: null,
                                })
                              }
                              className="rounded mr-8"
                              variant="primary"
                            >
                              Save
                            </Button>
                            <Button
                              hidden={!isFavorite}
                              onClick={() =>
                                handleRemoveSavedOpportunityFromSearchResults(
                                  isFavorite.id
                                )
                              }
                              className="rounded mr-8"
                              variant="outline-primary"
                              size="sm"
                            >
                              Unsave
                            </Button>
                          </div>
                        </td>
                      ),
                    };
                  })}
                  onSort={(sort) => {
                    handleSortChange(sort);
                    fetchAndSetOrganizationData();
                  }}
                  onClick={(index: number) =>
                    console.log('index', index)
                  }
                />
              </div>
            </Col>
          </Row>
          <BusinessSearchResourcesNotice />
        </Container>
      </BreadCrumbWrapper>
    </BusinessWrapper>
  )
}

export default BusinessLenders;
